module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_028.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_028.png
// module id = 2375
// module chunks = 5